import { createFileRoute, redirect } from "@tanstack/react-router";

/** The League Matchup Bible template's old address: its page is the League OTP Bible's now. */
export const Route = createFileRoute("/use-cases/league-matchup-bible")({
  beforeLoad: () => {
    throw redirect({ href: "/use-cases/league-otp-bible", statusCode: 301 });
  },
});
